import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSetAtom } from 'jotai'
import { fetchAuthSession } from 'aws-amplify/auth'
import LoadingSpinner from '../components/LoadingSpinner'
import { userAtom, User } from '../state/auth'
import { usersApi } from '../services/api'

export default function Callback() {
  const navigate = useNavigate()
  const setUser = useSetAtom(userAtom)

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const session = await fetchAuthSession()
        const idToken = session.tokens?.idToken

        if (idToken) {
          const payload = idToken.payload
          console.log('[Callback] JWT Payload:', {
            email: payload.email,
            role: payload['custom:role'],
            name: payload.name,
            clientId: payload['custom:clientId'],
          })
          const user: User = {
            email: (payload.email as string) || '',
            role: (payload['custom:role'] as User['role']) || 'sales',
            name: payload.name as string | undefined,
            clientId: payload['custom:clientId'] as string | undefined,
            isManager: payload['custom:isManager'] === 'true',
          }
          // Also check DB record for isManager in case Cognito attribute hasn't propagated
          if (user.role !== 'client') {
            try {
              const users = await usersApi.list()
              const dbUser = users.find((u) => u.email === user.email)
              if (dbUser?.isManager) {
                user.isManager = true
              }
            } catch {
              // Non-critical
            }
          }
          console.log('[Callback] Setting user:', user)
          setUser(user)
        } else {
          console.warn('[Callback] No idToken found in session')
        }

        navigate('/', { replace: true })
      } catch (error) {
        console.error('Auth callback error:', error)
        navigate('/login')
      }
    }

    handleCallback()
  }, [navigate, setUser])

  return <LoadingSpinner />
}
